"use client";

// components/seo/WebVitalsReporter.tsx
// Captures Core Web Vitals (LCP, CLS, INP, FCP, TTFB) via Next's built-in
// useReportWebVitals hook and beacons each sample to /api/web-vitals. CWV is
// a ranking factor and was previously only visible in Sentry's own UI —
// nobody's /ops decisions were informed by it. This closes that gap by
// storing raw samples so /ops/performance can compute p75 per metric.

import { useReportWebVitals } from "next/web-vitals";

export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      path: window.location.pathname,
    });

    // sendBeacon fires-and-forgets even during page unload, which is when
    // several of these metrics (LCP, CLS) are finalized.
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/web-vitals", new Blob([body], { type: "application/json" }));
    } else {
      fetch("/api/web-vitals", { method: "POST", body, keepalive: true }).catch(() => {});
    }
  });

  return null;
}
